<div class="contribuicao">
  <h3>Informe os valores que deseja aplicar no plano de previdência</h3>
  <div [formGroup]="parentForm">

    <div formGroupName="contribuicao">

      <div class="valorsimulacao">
        <span> Valor da contribuição mensal <small>(em reais)</small></span>
        <div>
          <!-- <input
          formControlName="vlrCtbRange"
          (change)="onChangeInput($event.target.value)"
          (keyup.enter)="false"
          type="range"
          class="inputRange"
          max="10000"
          [min]="contribuicaoMinima"
          step="1"
          /> -->
          <div id="box-value">
            @if (menorQueCtbMinima) {
              <p id="minvalue">
                O valor mínimo é de {{contribuicaoMinima| currency:'R$'}} e
                <br />
                o máximo é de R$ 10.000,00.
              </p>
            }
            <input
              formControlName="vlrCtb"
              (change)="onChangeInput($event.target.value)"
              id="valor-mensal--input"
              placeholder="{{contribuicaoMinima| currency:'R$'}}"
              />
            </div>
          </div>
        </div>
        <div class="valorsimulacao">
          <span>Valor do primeiro aporte <small>(em reais)</small></span>
          <div>
            <!-- <input
            formControlName="vlrPrimeiroAporteCtbRange"
            (change)="onChangeInputPrimeiroAporte($event.target.value)"
            (keyup.enter)="false"
            type="range"
            class="inputRange"
            step="1"
            currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
            /> -->
            <div id="box-value">
              <!-- <p id="minvalue"  *ngIf="menorQueCtbMinima">
              O valor mínimo é de {{contribuicaoMinima| currency:'R$'}} e
              <br />
              o máximo é de R$ 10.000,00.
            </p> -->
            <input
              formControlName="vlrPrimeiroAporteCtb"
              (change)="onChangeInputPrimeiroAporte($event.target.value)"
              id="valor-mensal--input"
              placeholder="{{contribuicaoMinima| currency:'R$'}}"
              />
            </div>
          </div>
        </div>
        <div class="idade">
          <span>Idade prevista para solicitação do Benefício de Renda </span>
          <a (click)="openOneModal()">
            <small title="Saiba mais"><i class="fas fa-question-circle"></i> (ajuda)</small>
          </a>
          <div>
            <!-- <input
            formControlName="idadeAposRange"
            type="range"
            class="inputRange"
            (input)="onChangeInputIdade($event.target.value)"
            /> -->
            <div id="box-value">

              <input
                formControlName="idadeApos"
                (input)="onChangeInputIdade($event.target.value)"
                id="valor-mensal--input"
                mask="00"
                placeholder="60"
                />
              </div>
            </div>
          </div>
        </div>

        @if (!tiponedisabled) {
          <div class="info-modal">
            <ul>
              <li>
                O Participante no ato de inscrição deverá indicar uma idade prevista para solicitação do
                Benefício de Renda Programada para fins de projeção de renda a partir de 18 anos.
              </li>
            </ul>
            <button (click)="closeOneModal()" class="info-button__close">x</button>
          </div>
        }

